import _ from 'underscore';

import * as net from 'util/Net';
import * as TaskRunner from 'util/TaskRunner';

export function requestExportFile(fileId: string): Promise<void> {
  return TaskRunner.postJSONPromise({
    url: '/1/api/exports/',
    data: {file: fileId},
  });
}

export function requestBulkExportFiles(
  fileIds: Array<string>,
  exportType: string,
  format: string
): Promise<void> {
  return TaskRunner.postJSONPromise({
    url: '/1/api/exports/',
    data: {fileIds, exportType, format},
  });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function requestExportFolders(folderIds: Array<string>, exportType: string, data: any): Promise<void> {
  return TaskRunner.postJSONPromise({
    url: '/1/api/exports/',
    // eslint-disable-next-line no-restricted-syntax
    data: _.extend({folders: folderIds, exportType}, data),
  });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function requestPatentsafeExportTask(fileId: string): JQueryPromise<any> {
  return TaskRunner.runTask({
    url: '/1/api/exports/patentsafe',
    method: 'POST',
    contentType: 'application/json',
    data: JSON.stringify({fileId}),
  });
}

export function downloadStringContents(filename: string, content: string): void {
  net.submitCSRFForm('POST', '/1/api/exports/text-to-file', {datas: [{filename, content}], target: '_blank'});
}
